import type { Root } from 'mdast';
import type { State } from '../state';

export function root(state: State, node: Root): void {
	state.openNode(state.schema.topNodeType);
	state.parseTokens(node.children);
}
